export class Vector2 {
  public onChange: ((vector: Vector2) => void) | null = null;

  private _x: number;
  private _y: number;

  get x(): number {
    return this._x;
  }

  set x(newValue: number) {
    if (this._x === newValue) return;
    this._x = newValue;
    this.onChange && this.onChange(this);
  }

  get y(): number {
    return this._y;
  }

  set y(newValue: number) {
    if (this._y === newValue) return;
    this._y = newValue;
    this.onChange && this.onChange(this);
  }

  constructor(x: number = 0, y: number = 0) {
    this.set(x, y);
  }

  public set(x: number, y: number) {
    if (this._x === x && this._y === y) return;
    this._x = x;
    this._y = y;
    this.onChange && this.onChange(this);
  }

   public setSilent(x: number, y: number) {
    this._x = x;
    this._y = y;
  }

  public add(x: number, y: number): this {
    this.set(this.x + x, this.y + y);
    return this;
  }

  public divide(xDivider: number, yDivider: number): this {
    this.set(this.x / xDivider, this.y / yDivider);
    return this;
  }

  public toString(): string {
    return `${this._x}x${this._y}`;
  }

  public isZero(): boolean {
    return (this._x === 0 && this._x === 0);
  }

  public normalize(): this {
    if (!this.isZero()) {
      const m = this.getMagnitude();
      this.set(this.x / m, this.y / m);
    }

    return this;
  }

  public getMagnitude(): number {
    return Math.sqrt((this.x * this.x) + (this.y * this.y));
  }

  public multiply(x: number, y?: number): this {
    if (y === undefined) y = x;
    this.set(this.x * x, this.y * y);
    return this;
  }
}